<template>
  <div class="partner-item" @click="handleClick" data-url="{{ partner.url }}">
    <img :src="partner.logo" :alt="partner.name" class="partner-logo" />
    <p class="partner-name">{{ partner.name }}</p>
  </div>
</template>

<script>
export default {
  name: 'PartnerItem',
  props: {
    partner: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click', this.partner.url);
    },
  },
};
</script>

<style scoped>
.partner-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem;
}

.partner-logo {
  width: 100px;
  height: auto;
  margin-bottom: 0.5rem;
}

.partner-name {
  font-size: 14px;
  color: #333;
}
</style>
